import { getInstalledTwaVersion } from '$func/environmentInfo'
import { TWA_API_SUPPORT } from '$logic/twaCommunication/constant'

const installedTwaVersion = getInstalledTwaVersion()

enum OLD_TWA_EVENTS {
  CHECK_CONTACT_PERMISSION = 'checkContactPermission',
  CHECK_NOTIF_PERMISSION = 'checkNotifPermission',
  LOGOUT = 'logout',
  OPEN_FILE = 'openFile',
  SYNC_CONTACT = 'syncContacts',
  AUTH_TOKEN = 'auth_token',
  EDIT_NOTIFICATION = 'EDIT',
  DELETE_NOTIFICATION = 'DELETE',
  SEEN_NOTIFICATION = 'SEEN',
  FOCUS_ON_CALL_IS_NEEDED = 'focusOnCallIsNeeded',
  PING = 'Ping',
  END_ONGOING_CALL = 'endOngoingCall',
  REJECT_INCOMING_CALL = 'rejectIncomingCall',
  SHOW_INCOMING_CALL_NOTIFICATION = 'showIncomingCallNotification',
  SHOW_ONGOING_CALL_NOTIFICATION = 'showOngoingCallNotification',
  CLEAR_CONTACTS_HISTORY = 'clearContactsHistory',
  AUTO_SYNC_CONTACTS = 'autoSyncContacts',
}

enum NEW_TWA_EVENTS {
  CHECK_CONTACT_PERMISSION = 'reqGrantContactPermission',
  CHECK_NOTIF_PERMISSION = 'reqGrantNotifPermission',
  LOGOUT = 'reqLogout',
  OPEN_FILE = 'openFile',
  SYNC_CONTACT = 'reqSyncContacts',
  AUTH_TOKEN = 'reqSetAuthToken',
  EDIT_NOTIFICATION = 'reqEditNotification',
  DELETE_NOTIFICATION = 'reqDeleteNotification',
  SEEN_NOTIFICATION = 'reqSeenNotification',
  PING = 'reqPing',
  END_ONGOING_CALL = 'reqEndOnGoingCall',
  REJECT_INCOMING_CALL = 'reqRejectIncomingCall',
  SHOW_INCOMING_CALL_NOTIFICATION = 'reqShowIncomingCallNotification',
  SHOW_ONGOING_CALL_NOTIFICATION = 'reqShowOngoingCallNotification',
  CLEAR_CONTACTS_HISTORY = 'reqClearContactsHistory',
  AUTO_SYNC_CONTACTS = 'reqAutoSyncContacts',
}

export const TWA_EVENTS =
  TWA_API_SUPPORT.API_VERSION === 1 ? OLD_TWA_EVENTS : NEW_TWA_EVENTS

export type TwaEventTypeField = NEW_TWA_EVENTS | OLD_TWA_EVENTS

export interface TwaEvent {
  type: TwaEventTypeField
  payload?: any
}
